module.exports = __webpack_public_path__ + "c9d35105.jpg";